module.exports = __webpack_public_path__ + "static/img/ios1.0df0c51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios1.jpg
// module id = g8Hl
// module chunks = 1